import React from "react";
import PreconAuthoringPage from "./pages/PreconAuthoringPage";
import "./styles/preconAuthoring.scss";

export default function PreconAuthoring() {
  return (
    <div className="preconAuthoring">
      <PreconAuthoringPage />
    </div>
  );
}
